import { Button, Dialog, DialogContent, Grid, LinearProgress, Paper, TextField } from '@material-ui/core';
import React, { useState } from 'react';
import { FisCode } from '../../model/FisCode';

class Props {
    close : () => void;
    add : (fisCode: FisCode) => void;
}


const AddFisCode = (props: Props) => {
    const [fisCode, setFisCode] = useState(new FisCode());
    const [loading, setLoading] = useState(false);
    return <Dialog
                disableEscapeKeyDown
                maxWidth="xs"
                aria-labelledby="confirmation-dialog-title"
                open={true}
            ><DialogContent>
                {loading && <LinearProgress color="secondary"/>}
                <Grid container spacing={2} style={{padding:10}}>
                <Grid item xs={12}>
                    <TextField type="number" style={{ flex: 1, margin: '0 3px' }} id="standard-basic" label="Fiskod" value={fisCode.fisCode ?? ""} onChange={(ev) => {
                        setFisCode({...fisCode, fisCode: +ev.target.value});
                    }} fullWidth />
                </Grid>
                <Grid item xs={6}>
                    <TextField style={{ flex: 1, margin: '0 3px' }} id="standard-basic" value={fisCode.firstName} 
                    
                  onChange={(ev) => {
                        setFisCode({...fisCode, firstName: ev.target.value});
                    }} label="Förnamn" fullWidth />
                </Grid>
                <Grid item xs={6}>
                    <TextField style={{ flex: 1, margin: '0 3px' }} id="standard-basic" value={fisCode.lastName} 
                    
                  onChange={(ev) => {
                        setFisCode({...fisCode, lastName: ev.target.value});
                    }} label="Efternamn" fullWidth />
                </Grid>
                <Grid item xs={12}>
                    <TextField style={{ flex: 1, margin: '0 3px' }} id="standard-basic" value={fisCode.club}   onChange={(ev) => {
                        setFisCode({...fisCode, club: ev.target.value});
                    }} label="Klubb" fullWidth />
                </Grid>                   
                <Grid item xs={12}>     
                        <Button variant='contained' color="secondary" onClick={() => {setLoading(true); props.add(fisCode)}}>Spara</Button>
                        <Button variant='contained' style={{ marginLeft: 5 }} color="secondary" onClick={() => { props.close() }}>Avbryt</Button>
                </Grid>
            </Grid></DialogContent></Dialog>;
}

export default AddFisCode;
